import { useNavigate } from 'react-router-dom';

export const useLogout = () => {
  const navigate = useNavigate();

  const logout = async () => {
    try {
      console.log('coming to logoutUser');
    } catch (error) {
      console.error('Logout API failed', error);
    } finally {
      localStorage.setItem('logout-event', Date.now().toString());
      localStorage.clear();
      sessionStorage.clear();

      navigate('/facility/login', { replace: true, state: { logout: true } });
    }
  };

  return logout;
};
